import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { AccountDetailsEventFlow, TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

type TrackVerifyEmailSubmittedPayload = TrackingPayload & {
    eventFlow: AccountDetailsEventFlow;
};

const trackVerifyEmailSubmittedAnalytics = (payload: TrackVerifyEmailSubmittedPayload) => {
    track(TrackingEvents.Account.EmailVerificationCodeSubmitted, payload);
};

export const useTrackVerifyEmailSubmittedAnalytics = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(() => {
        trackVerifyEmailSubmittedAnalytics({
            eventFlow: AccountDetailsEventFlow.AccountCreation,
            pageName: getAmplitudePageNameFromPath(pathname),
            url,
        });
    }, [pathname, url]);
};
